import { userGetCurrent } from '@uncinc/react-drupal-core';
import { ENTITY_STATUS } from '@uncinc/react-drupal-core/dist/redux/actions/Entity';
import { SET_LOGGED_IN } from '@uncinc/react-drupal-core/dist/redux/actions/Login';

import { resetUserData } from '../actions/Entity/User';

const sessionMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  switch (action.type) {
    case ENTITY_STATUS: {
      // If the entity status returns 403 (access denied for entity) we want to check
      // if the user is still logged in or not. The user's session might have expired,
      // so we want to make sure to clear the user's session in the store if this is
      // the case. This userGetCurrent call takes care of this.
      if (action.status === 403) {
        dispatch(userGetCurrent());
      }

      break;
    }

    case SET_LOGGED_IN: {
      // If a user has logged out, either by actively logging out or when the session
      // has expired, reset all their user data.
      if (action.data === false) {
        dispatch(resetUserData());
      }

      break;
    }
  }

  return next(action);
};

export default sessionMiddleware;
